export enum ReportContext {
  Risks = 1,
  Schedule = 2,
  Controls = 4,
  Assets = 5,
  Processes = 6,
  Requirements = 7,
  Objectives = 8,
  Library = 9,
  Tasks = 10,
  ProcessingActivities = 11,
  ProcessingActivityDetails = 12,
}

export enum ReportType {
  RiskAssesment = 1,
  RiskTreatmentPlan = 2,
  OperationalPlanning = 3,
  SOA_Controls = 6,
  Assets = 7,
  ControlImplementation = 8,
  ProcessRiskControl = 9,
  AssetRiskControl = 10,
  RequirementImplementation = 11,
  ProcessDetails = 12,
  ObjectiveDetails = 13,
  AssetDetails = 14,
  LibraryPublicationHistory = 15,
  Tasks = 16,
  RiskChanges = 17,
  ControlSpecification = 18,
  ProcessingActivities = 19,
  ProcessingActivityDetails = 20,
  SuppliersProcessingActivities = 21,
  ProcessingActivitiesDataSubjects = 22,
  RecurringTaskGantt = 23,
  TasksAndEvents = 24,
}

export default class ReportDefinition {
  id: ReportType;

  name: string;

  description: string;

  icon: string;

  context: ReportContext[];

  contextUrl?: string;

  optionsHeight?: number;

  allowWordExport?: boolean;

  disableExcelExport?: boolean;

  disablePdfExport?: boolean;

  allowPdfDownloadWithoutSharePoint?: boolean;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
    this.description = '';
    this.icon = '';
    this.context = [];
  }

  canExportWord(): boolean {
    return this.allowWordExport !== false;
  }

  canExportExcel(): boolean {
    return this.disableExcelExport !== true;
  }

  canExportPdf(sharePointEnabled: boolean): boolean {
    return this.disablePdfExport !== true && (sharePointEnabled || this.allowPdfDownloadWithoutSharePoint === true);
  }
}
